import { css } from "styled-components";

export const PaginationStyles = css(({ theme }) => ({
    ".Pagination": {
        "&&": {
            ".PagesList": {
                ".PaginationItem": {
                    ...theme.typography.body2Regular.style,
                    "&.Sm": {
                        height: "2rem",
                        width: "2rem",
                    },
                    "&.Md": {
                        height: "2.75rem",
                        width: "2.75rem",
                    },
                    "&.Lg": {
                        height: "3rem",
                        width: "3rem",
                    },
                    "&.first, &.last, &.previous, &.next": {
                        border: `1px solid ${theme.palette.overlays[900][8]}`,
                    },
                    "&:hover:not(.Disabled):not(.start-ellipsis):not(.end-ellipsis)": {
                        backgroundColor: theme.palette.overlays[900][8],
                    },
                    "&.Selected": {
                        ...theme.typography.body2Strong.style,
                        backgroundColor: theme.palette.gray[900] + " !important",
                        color: theme.palette.gray[0],
                        "&.Disabled": {
                            backgroundColor: theme.palette.disabled,
                        },
                    },
                },
            },
        },
    },
}));
